export default __webpack_public_path__ + "maturity-date-dc3a8a243456421bd9a2d127e97e5c85.svg";